import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import BankAccountsViewModel from "../../../viewModels/finance/bankAccounts/bankAccountsViewModel";
import ListView from "../../common/list";
import { registerView } from "@frui.ts/views/dist";
import { formatBankAccount } from "@edaz/utils/bankAccount";

const BankAccountsView: ViewComponent<BankAccountsViewModel> = observer(({ vm }) => {
  return (
    <ListView
      vm={vm}
      columns={[
        {
          title: vm.translateAttribute("description"),
          property: "description",
        },
        {
          title: vm.translateAttribute("sourceType"),
          property: "sourceType",
          valueFormatter: props => vm.translateEnum("sourceType", props.item.sourceType),
        },
        {
          title: vm.translateAttribute("bankAccount"),
          property: "bankAccount",
          valueFormatter: props => formatBankAccount(props.value),
        },
        {
          title: vm.translateAttribute("iban"),
          property: "iban",
        },
        {
          title: vm.translateAttribute("status"),
          property: "status",
          valueFormatter: props => vm.translateBankAccStatus("bankAccountStatus", props.item.status),
        },
        {
          title: vm.translateAttribute("currencyCode"),
          property: "currencyCode",
        },
      ]}
    />
  );
});

registerView(BankAccountsView, BankAccountsViewModel);
